const h1 = document.querySelector(".collection-hero__text-wrapper");
const header = document.querySelector(".header");


window.addEventListener("DOMContentLoaded", () => {
  const megaMenu = document.querySelectorAll(".mega-menu");
  const menuContainer = document.querySelector(".header-wrapper");

  //change bg-color of header and show mega-menu on hover links with child links
  megaMenu.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      if (!item.hasAttribute("open")) {
        if (h1) {
          h1.classList.add("hidden");
        }
        menuContainer.classList.add("active");
        item.setAttribute("open", ""); // -> <div open> setAttribute("open", "")
        item.classList.add("active");
      }
    });
  });
  
  const megaMenuLinks = menuContainer.querySelectorAll("ul.list-menu > li > a");
  megaMenuLinks.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      menuContainer.classList.remove("active");
      menuContainer.querySelector(".mega-menu.active").removeAttribute("open");
      menuContainer.classList.remove("active");

      if (h1) {
        h1.classList.remove("hidden");
      }
    });
  });

  const megaMenuContent = menuContainer.querySelector(".mega-menu__content");
  megaMenuContent.addEventListener("mouseleave", () => {
    menuContainer.querySelector(".mega-menu.active").removeAttribute("open");
    menuContainer.classList.remove("active");
    if (h1) {
      h1.classList.remove("hidden");
    }
  });
})